import { Flex, Avatar, Box, Button, Text, Icon } from '@chakra-ui/react';
import { selectUsers } from '@/store/users/selectors';
import { useSelector } from 'react-redux';
import { decode } from 'js-base64';

import { useNotificationCard, NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import IntroRequestMade from '@/assets/icons/notification/IntroRequestMade';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { NotificationLink } from '../components/NotificationLink';

const IntroWrapper = ({ notification = () => {}, onClose = () => {} }) => {
  const users = useSelector(selectUsers);
  const { topic, custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const requester = users?.find((user) => user.id === data?.requester_id);
  const introId = topic.split(':')[1];
  const { markAsRead } = useNotificationCard();
  const { track } = useMixpanel();

  const makeIntro = () => {
    markAsRead();
    track({
      module: 'in-app-notification',
      data: {
        'user-event': 'click',
        'user-action': 'make-intro',
      },
    });
    window.open(`/contacts/${data.contact_id}?introId=${introId}&type=accept`);
  };
  const denyIntro = () => {
    markAsRead();
    track({
      module: 'in-app-notification',
      data: {
        'user-event': 'click',
        'user-action': 'deny-intro',
      },
    });
    window.open(`/contacts/${data.contact_id}?introId=${introId}&type=deny`);
  };
  return (
    <Flex>
      <Box>
        <Box height="40px" pos="relative">
          <Avatar
            width="36px"
            height="36px"
            borderRadius="8px"
            className="avatar-md"
            name={requester?.name}
            src={requester?.avatar}
          />
          <Box pos="absolute" bottom="-24px" left="9px">
            <Icon as={IntroRequestMade} width="40px" height="40px" />
          </Box>
        </Box>
      </Box>
      <Box ml="12px">
        <Flex pr="12px">
          <Text>
            <Text as="span" fontWeight="semiBold" pr="4px">
              {data.requester_name}
            </Text>
            have requested
            <Text as="span" px="4px" fontWeight="semiBold">
              You
            </Text>
            for an intro to
            <NotificationLink
              to={`/contacts/${data.contact_id}`}
              label={data.candidate_name}
              onClose={onClose}
              notification={notification}
              data-test-id="candidate-link"
            />
          </Text>
        </Flex>
        <NotificationTime notification={notification} />
        <Box mt="12px">
          <Button onClick={makeIntro} data-test-id="make-intro-button">
            Make intro
          </Button>
          <Button
            onClick={denyIntro}
            ml="12px"
            variant="secondary"
            data-test-id="decline-intro-button"
          >
            Decline
          </Button>
        </Box>
      </Box>
    </Flex>
  );
};

export const Intro = ({ notification = {}, onClose = () => {} }) => {
  return (
    <NotificationCard notification={notification}>
      <IntroWrapper notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
